import { uaIsIOS } from '@/utils/helpers'

/**
 * テキストを Clipboard に copy
 * iOS10 移行に対応
 * https://stackoverflow.com/questions/34045777/copy-to-clipboard-using-javascript-in-ios
 */
export const copyToClipboard = (text: string): boolean => {
  // Create textarea
  let textarea: HTMLTextAreaElement = document.createElement('textarea')
  textarea.value = text
  const posY = window.pageYOffset
  document.body.appendChild(textarea)
  window.scrollTo(0, posY)

  // Select text
  if (uaIsIOS) {
    const range = document.createRange()
    range.selectNodeContents(textarea)
    const selection = window.getSelection()
    selection.removeAllRanges()
    selection.addRange(range)
    textarea.setSelectionRange(0, 999999)
  } else {
    textarea.select()
  }

  // Copy to clipboard
  const ret = document.execCommand('copy')
  document.body.removeChild(textarea)
  textarea = null

  return ret
}

/**
 * 要素(input or textarea)のテキストを Clipboard に copy
 * iOS10 移行に対応
 * https://stackoverflow.com/questions/34045777/copy-to-clipboard-using-javascript-in-ios
 */
export const copyElementTextToClipboard = (
  element: HTMLInputElement | HTMLTextAreaElement
): boolean => {
  // Select text
  if (uaIsIOS) {
    // save current contentEditable/readOnly status
    const editable = element.contentEditable
    const readOnly = element.readOnly

    // convert to editable with readonly to stop iOS keyboard opening
    element.contentEditable = 'true'
    element.readOnly = true

    // create a selectable range
    const range = document.createRange()
    range.selectNodeContents(element)

    // select the range
    const selection = window.getSelection()
    selection.removeAllRanges()
    selection.addRange(range)
    element.setSelectionRange(0, 999999)

    // restore contentEditable/readOnly to original state
    element.contentEditable = editable
    element.readOnly = readOnly
  } else {
    element.select()
  }

  // Copy to clipboard
  return document.execCommand('copy')
}
